/**
 * Dutch (nl-NL) thousands grouping for whole numbers. Single source of truth for the
 * vehicle mileage (kilometerstand) separator so the input (live, via wppNumericInput's
 * group mode) and the read-only summary/overview displays all render it identically.
 */

// "123456" → "123.456". Strips any non-digits first, so an already-grouped or
// comma-separated value re-groups cleanly. Empty / no digits → "".
import { t } from './translate';

export function groupThousands(value: string | number | null | undefined): string {
  const digits: string = String(value ?? '').replace(/\D/g, '');
  return digits ? Number(digits).toLocaleString('nl-NL') : '';
}

// Mileage for read-only display. The -1 "not entered" sentinel and null/undefined → ""
// so the caller can pick its own placeholder (e.g. "-").
export function formatMileage(km: number | null | undefined): string {
  if (km == null || km < 0) {
    return '';
  }
  return groupThousands(km);
}

// Same, with the unit appended: 123456 → "123.456 km". Empty value → "" (no stray " km").
export function formatMileageKm(km: number | null | undefined): string {
  const formatted: string = formatMileage(km);
  return formatted ? t('wpp.number-format.mileage-km', { mileage: formatted }) : '';
}
